module.exports = roosterjsLegacy;